import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DconConfigAPI } from '../config/config';
import { CommonServicesService } from '../services/common-services.service';
@Injectable({
  providedIn: 'root'
})

export class DconSharedService {
  public sharedData = new BehaviorSubject(null);
  public data: any;
  public userPermissionBaseUrl: any;
  resData: any;
  constructor(private _https: HttpClient, public _httpService: CommonServicesService,
  ) {

  }

  ngOnInit(): void {
    this.getData();
  }

  callDconSecurityCredApi(loader: boolean = true) {
    console.log('callDconSecurityCredApi', DconConfigAPI.KEYVAULT_API_URL + DconConfigAPI.DCON_SECURITY_CREDENTIALS);
    return this._https.get(DconConfigAPI.KEYVAULT_API_URL + DconConfigAPI.DCON_SECURITY_CREDENTIALS);
  }

  callUserPermissionApi(url, options) {
    console.log('callUserPermissionApi', url + "dfteworkbench/user/userpermission?grant_type=client_credentials", options);
    return this._https.get(url + "dfteworkbench/user/userpermission?grant_type=client_credentials", options).subscribe((response) => {
      this.data = response;
    });
  }

  getData() {
    this.userPermissionBaseUrl = DconConfigAPI.SW_ORDS_BASE_URL;
    this._https.get(this.userPermissionBaseUrl = DconConfigAPI.SW_ORDS_BASE_URL
    ).subscribe(res => {
      this.resData = res;
    });
  }
}
